import {
    GetOpraReportTemplatesRes,
    GetPowerBIReportTemplatesRes,
    OpraReportTemplate,
} from '@interfaces/report-templates.interface';
import { orderBy } from '@progress/kendo-data-query';
import { TFunction } from 'i18next';
import { restructuredUpdatedCreatedBy } from '@utils-clean/update-users-array';

export interface CustomReportTemplateFields extends OpraReportTemplate {
    _orgDbId?: string;
    _itemId?: string;
    _createdByString?: string;
    _updatedByString?: string;
    _powerBITemplateName?: string | null;
    _customTemplateName?: string | null;
}

export const filterRetiredAndPublishedTemplates = (orgReportTemplates?: GetOpraReportTemplatesRes) =>
    orgReportTemplates?.filter(
        (temp) => temp.reportStatusName === 'Retired' || temp.reportStatusName === 'SuccessfullyPublished',
    );

export const setTemplateNamesAndPowerBINames = (
    t: TFunction,
    opraReportTemplates: CustomReportTemplateFields[],
    pbiReportTemplates: GetPowerBIReportTemplatesRes,
) => {
    opraReportTemplates.forEach((item) => {
        item._customTemplateName =
            item.moduleName === 'RAM' && !!item.includeInternalRisks
                ? `${t('internal').toUpperCase()} ${item.templateName}`
                : item.templateName;

        const result = pbiReportTemplates?.find((pbiItem) => pbiItem.id === item.pbiReportId);
        item._powerBITemplateName = result?.name;
    });
};

export const sortByNameAndSetDates = (
    t: TFunction,
    opraReportTemplates?: CustomReportTemplateFields[],
    pbiReportTemplates?: GetPowerBIReportTemplatesRes,
) => {
    if (!opraReportTemplates) return [];
    opraReportTemplates = restructuredUpdatedCreatedBy(opraReportTemplates);
    if (pbiReportTemplates) setTemplateNamesAndPowerBINames(t, opraReportTemplates, pbiReportTemplates);
    return orderBy(opraReportTemplates, [{ field: '_customTemplateName', dir: 'asc' }]);
};
